<template>
  <div class="main-page">
    <template v-if="showHeader">
      <section class="page-section">
        <div class="container-fluid">
          <div class="grid justify-content-between">
            <div class="col">
              <div class="">
                <div class="text-3xl card font-bold">User Account Details</div>
              </div>
            </div>
            <div class="col-12">
              <div class="">
                <Breadcrumb
                  :home="{
                    icon: 'pi pi-arrow-left text-lg mr-3',
                    label: 'Back',
                    command: () => {
                      $router.go(-1);
                    },
                  }"
                  :model="[
                    {
                      label: 'User Accounts',
                      to: '/users',
                    },
                  ]"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </template>
    <section class="page-section pt-1">
      <div class="container-fluid">
        <div class="grid">
          <div class="col-12 md:col-8 comp-grid">
            <div class="">
              <div class="">
                <div>
                  <div class="relative-position" style="min-height: 100px">
                    <template v-if="pageReady">
                      <div class="grid">
                        <div class="col-12">
                          <div class="" :class="{ card: !isSubPage }">
                            <div class="grid align-items-center">
                              <div class="col">First Name:</div>
                              <div class="col font-bold">
                                {{ item.first_name }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Last Name:</div>
                              <div class="col font-bold">
                                {{ item.last_name }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Email:</div>
                              <div class="col font-bold">{{ item.email }}</div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Telephone Extension:</div>
                              <div class="col font-bold">
                                {{ item.telephone }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Region:</div>
                              <div class="col font-bold">{{ item.region }}</div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">District:</div>
                              <div class="col font-bold">
                                {{ item.district }}
                              </div>
                            </div>
                            <hr />
                            <!-- <div class="grid align-items-center">
                              <div class="col">User Role:</div>
                              <div class="col font-bold">
                                {{ item.user_role }}
                              </div>
                            </div>
                            <hr /> -->
                            <div class="grid align-items-center">
                              <div class="col">Date Created:</div>
                              <div class="col font-bold">
                                {{ $utils.humanDatetime(item.date_created) }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Last Updated:</div>
                              <div class="col font-bold">
                                {{ $utils.humanDatetime(item.date_updated) }}
                              </div>
                            </div>
                            <hr />
                            <div class="flex justify-btween">
                              <SplitButton
                                class="p-button p-button-raised p-button-text p-button-sm"
                                :model="getActionMenuModel(item)"
                              >
                                <i></i>
                              </SplitButton>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-if="loading">
                      <div>
                        <table class="p-datatable-table w-full">
                          <tbody>
                            <tr v-for="n in 5" :key="n">
                              <td class="text-left" style="width: 100%">
                                <Skeleton height="2rem" class="m-2" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 md:col-4 comp-grid">
            <div class="">
              <div class="">
                <div>
                  <ActivitiesListPage
                    ref="activitiesListPage"
                    :limit="4"
                    field-name="activities.user_id"
                    :field-value="id"
                    sort-by="activities.date_created"
                    sort-type="DESC"
                    :show-header="true"
                    :show-breadcrumbs="true"
                    :show-footer="true"
                    :paginate="true"
                    v-if="pageReady"
                  >
                  </ActivitiesListPage>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script setup>
import { toRefs, onMounted } from "vue";
import { utils } from "@/utils";
import { useApp } from "@/composables/app.js";
import { useViewPage } from "@/composables/viewpage.js";
import ActivitiesListPage from "../activities/list.vue";
const props = defineProps({
  id: [String, Number],
  primaryKey: {
    type: String,
    default: "user_id",
  },
  pageName: {
    type: String,
    default: "users",
  },
  routeName: {
    type: String,
    default: "usersview",
  },
  apiPath: {
    type: String,
    default: "users/view",
  },
  editButton: {
    type: Boolean,
    default: true,
  },
  deleteButton: {
    type: Boolean,
    default: true,
  },
  exportButton: {
    type: Boolean,
    default: true,
  },
  titleBeforeDelete: {
    type: String,
    default: "Delete record",
  },
  msgBeforeDelete: {
    type: String,
    default: "Record deleted successfully",
  },
  msgAfterDelete: {
    type: String,
    default: "Record deleted successfully",
  },
  showHeader: {
    type: Boolean,
    default: true,
  },
  showFooter: {
    type: Boolean,
    default: true,
  },
  isSubPage: {
    type: Boolean,
    default: false,
  },
});
const app = useApp(props);
const page = useViewPage(props); // page hook
//page state
const {
  item, // current record from store - Object
  loading, // api loading state
  pageReady, // api data loaded successfully
} = toRefs(page.state);
//page computed propties
const {
  apiUrl, // page current api path
  currentRecord, // current page record  - Object
} = page.computedProps;
//page methods
const {
  load, // load data from api
  deleteItem, // deleted current record
  exportPage, // export page records - args = (exportFormats, apiUrl, pageName)
  moveToNextRecord, // load next record from api
  moveToPreviousRecord, // load previous record from api
} = page.methods;
function getActionMenuModel(data) {
  return [
    {
      label: "Edit",
      command: (event) => {
        app.openPageDialog({
          page: "users/edit",
          url: `/users/edit/${data.user_id}`,
          closeBtn: true,
          position: "bottom",
        });
      },
      icon: "pi pi-pencil",
    },
    {
      label: "Delete",
      command: (event) => {
        deleteItem(data.user_id);
      },
      icon: "pi pi-minus-circle",
    },
  ];
}
onMounted(() => {
  const pageTitle = "User Account Details";
  app.setPageTitle(props.routeName, pageTitle); // set browser page title
  load();
});
</script>
<style scoped></style>
<style scoped></style>
